// removed by extract-text-webpack-plugin
module.exports = {"root":"_2b4uX0h","page":"_2UKqRah","page_isActive":"_2454KzL","first":"_1JPFnwB","previous":"_15Lz-s4","next":"_1XIONbW","showFirst":"_258amNL"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/Pagination/Pagination.less
 ** module id = 872
 ** module chunks = 0
 **/